import { render, staticRenderFns } from "./ExtractTextModal.vue?vue&type=template&id=56b8a996&scoped=true"
import script from "./ExtractTextModal.vue?vue&type=script&lang=js"
export * from "./ExtractTextModal.vue?vue&type=script&lang=js"
import style0 from "./ExtractTextModal.vue?vue&type=style&index=0&id=56b8a996&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b8a996",
  null
  
)

export default component.exports